import { useSelector, useDispatch } from 'umi';

type IPageStoreNamespace =
  | 'dbg-model-pipeline-project-list-locker'
  | 'dbg-model-pipeline-overview-schedule-locker'
  | 'dbg-model-studio-monthly-report-performance-overview-locker'
  | (string & {});

export default function usePageStore<T extends unknown = {}>(namespace: IPageStoreNamespace) {
  const dispatch = useDispatch();

  const lockerData = useSelector<any, T>((rootState) => rootState?.[namespace] || {});

  const setLockerData = (payload: Partial<T>) => {
    dispatch({ type: `${namespace}/updateLockerData`, payload });
  };

  const clearLockerData = () => {
    dispatch({ type: `${namespace}/clearLockerData` });
  };

  return { lockerData, setLockerData, clearLockerData };
}
